import { LoadingSpinner } from "../../../../components/LoadingSpinner"
import AuthPageLayout from "../../../platform-layout/components/AuthPageLayout"
import AuthHeader from "../../components/AuthHeader"
import ForgotPasswordBox from "../components/ForgotPasswordBox"
import { useForgotPassword } from "../hooks/useForgotPassword"

const ForgotPassword = () => {
    const { onBackButtonClick, handleInputSubmit, isLoading, emailErrorText } = useForgotPassword()

  return (
    <AuthPageLayout>
            <AuthHeader
                onBackClick={onBackButtonClick}
            />
            <div className="w-full flex-1 flex flex-col items-center justify-center mt-[80px] overflow-hidden ">
                <div className="w-full sm:w-[328px] md:w-[400px] lg:w-[500px] p-[20px] bg-white">
                    <ForgotPasswordBox
                        onSubmit={handleInputSubmit}
                        emailErrorText={emailErrorText}
                    />
                </div>
            </div>
            {
                isLoading && <LoadingSpinner />
            }
        </AuthPageLayout>
  )
}

export default ForgotPassword
